import React from "react";
import { isIOS } from "react-device-detect";
import { useTranslation } from "react-i18next";
import images from "../../../images";
import { formatDateForCalendar } from "../../../Utils/helper";

const NotifyMeButton = ({ questData, customStartDate }) => {
  const { t } = useTranslation();

  const startTimeRaw = customStartDate || questData?.quest_business?.start_time;

  if (!startTimeRaw) return null;

  const businessName = questData?.quest_business?.name || "Rally Quest";
  const description = questData?.quest_business?.description || "";
  const locationAddress = questData?.location?.address || "Online";

  const getEventDates = () => {
    const startDateObj = new Date(
      startTimeRaw.endsWith("Z") ? startTimeRaw : startTimeRaw + "Z",
    );

    const endDateObj = new Date(startDateObj.getTime() + 60 * 60 * 1000);

    return {
      start: formatDateForCalendar(startDateObj),
      end: formatDateForCalendar(endDateObj),
    };
  };

  const { start, end } = getEventDates();

  const downloadICSFile = () => {
    const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
DTSTART:${start}
DTEND:${end}
SUMMARY:${businessName}
DESCRIPTION:${description}
LOCATION:${locationAddress}
END:VEVENT
END:VCALENDAR`;

    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "rally-quest.ics");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openGoogleCalendar = () => {
    const googleUrl = new URL("https://calendar.google.com/calendar/render");
    googleUrl.searchParams.append("action", "TEMPLATE");
    googleUrl.searchParams.append("text", businessName);
    googleUrl.searchParams.append("dates", `${start}/${end}`);
    googleUrl.searchParams.append("details", `${description}\n\n`);
    googleUrl.searchParams.append("location", locationAddress);

    window.open(googleUrl.toString(), "_blank");
  };

  const handleNotifyClick = () => {
    if (isIOS) {
      downloadICSFile();
    } else {
      openGoogleCalendar();
    }
  };

  return (
    <div className="w-full mt-0">
      <button
        onClick={handleNotifyClick}
        className="w-full font-medium py-2.5 xs:py-4 text-white bg-[#253FF6] rounded-md text-base xs:text-xl flex items-center justify-center gap-2 "
        type="button"
      >
        <img
          src={images.AlarmClockIcon}
          alt=""
          className="w-5 h-5 filter brightness-0 invert"
        />
        <span>{t("quest.taskQuest.notifyMe") || "Notify Me"}</span>
      </button>
    </div>
  );
};

export default NotifyMeButton;
